import { Card } from 'reactstrap';
import { StudentsRiskHistoryDetailsLoader } from './loaders/StudentsRiskHistoryDetailsLoader';
import StudentsRiskHistoryDetailsActionsTable from './StudentsRiskHistoryDetailsActionsTable';
import StudentsRiskHistoryDetailsBoxes from './StudentsRiskHistoryDetailsBoxes';
import StudentsRiskHistoryDetailsHeader from './StudentsRiskHistoryDetailsHeader';
import StudentsRiskHistoryDetailsHistoryTable from './StudentsRiskHistoryDetailsHistoryTable';
import { StudentsRiskHistoryDetailsRouteParams } from './types';

type StudentListDetailsComponentProps =
  | {
      origin: 'riskSession' | 'riskSessionHistory';
      sessionEnrollmentId: StudentsRiskHistoryDetailsRouteParams['sessionEnrollmentId'];
    }
  | {
      origin: 'studentFile';
      studentId: StudentsRiskHistoryDetailsRouteParams['studentId'];
    };

export function StudentListDetailsComponent(
  params: StudentListDetailsComponentProps,
) {
  return (
    <div className="mx-3">
      <Card className="p-4">
        <StudentsRiskHistoryDetailsLoader
          fetchImmediately
          defaultQuery={params}
        >
          <StudentsRiskHistoryDetailsHeader origin={params.origin} />
          <StudentsRiskHistoryDetailsBoxes origin={params.origin} />
          <StudentsRiskHistoryDetailsHistoryTable origin={params.origin} />
          <StudentsRiskHistoryDetailsActionsTable origin={params.origin} />
        </StudentsRiskHistoryDetailsLoader>
      </Card>
    </div>
  );
}
